import './App.css';
import * as React from "react";
import DesktopIntro from "./page/desktop/Intro"
import DesktopVersionPick from "./page/desktop/VersionPick"
import DesktopClosingPick from "./page/desktop/ClosingPick"
import DesktopFastenerPick from "./page/desktop/FastenerPick"
import DesktopResult from "./page/desktop/Result";
import DesktopTypePick from "./page/desktop/TypePick";
import DesktopSituationPick from "./page/desktop/SituationPick";
import DesktopContactPick from "./page/desktop/ContactPick";
import PhoneIntro from "./page/phone/Intro"
import PhoneVersionPick from "./page/phone/VersionPick"
import PhoneClosingPick from "./page/phone/ClosingPick"
import PhoneFastenerPick from "./page/phone/FastenerPick"
import PhoneResult from "./page/phone/Result";
import PhoneTypePick from "./page/phone/TypePick";
import PhoneSituationPick from "./page/phone/SituationPick";
import PhoneContactPick from "./page/phone/ContactPick";
import {useEffect, useState} from "react";
import PhoneStartMode from "./page/phone/PhoneStartMode";

const Page = {
    Intro: 1,
    VersionPick: 2,
    TypePick: 3,
    SituationPick: 4,
    ClosingPick: 5,
    FastenerPick: 6,
    ContactPick: 7,
    Result: 8,
}

function App() {
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);

    const [page, setPage] = useState(Page.Intro);
    const [VersionPick, setVersionPick] = useState(null);
    const [TypePick, setTypePick] = useState(null);
    const [SituationPick, setSituationPick] = useState(null);
    const [ClosingPick, setClosingPick] = useState(null);
    const [FastenerPick, setFastenerPick] = useState(null);
    const [ContactPick, setContactPick] = useState(null);
    const [phoneMode, _setPhoneMode] = useState(false);
    const setPhoneMode = (mode) => {
        if (mode) {
            window.history.pushState(null, null, window.location.href);
        }
        _setPhoneMode(mode);
    }
    useEffect(() => {
        function handleResize() {
            setScreenWidth(window.innerWidth);
        }

        window.addEventListener('resize', handleResize);

        function handleBackButton(e) {
            setPhoneMode(false);
            if (!phoneMode) {
                return;
            }

            window.history.pushState(null, null, window.location.href);
        }

        window.addEventListener('popstate', handleBackButton);
        return () => {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('popstate', handleBackButton);
        }
    }, []);

    const handlePageChange = (val) => {
        switch (page) {
            case Page.Intro:
                break;
            case Page.VersionPick:
                setVersionPick(val);
                setTypePick(null);
                setSituationPick(null);
                setClosingPick(null);
                setFastenerPick(null);
                setContactPick(null);
                break;
            case Page.TypePick:
                setTypePick(val);
                setSituationPick(null);
                setClosingPick(null);
                setFastenerPick(null);
                setContactPick(null);
                break;
            case Page.SituationPick:
                setSituationPick(val);
                setClosingPick(null);
                setFastenerPick(null);
                setContactPick(null);
                break;
            case Page.ClosingPick:
                setClosingPick(val);
                setFastenerPick(null);
                setContactPick(null);
                break;
            case Page.FastenerPick:
                setFastenerPick(val);
                setContactPick(null);
                break;
            case Page.ContactPick:
                setContactPick(val);
                break;
            default:
                console.error("Unknown page enum while updating page: " + page)
        }
    }

    const handleNextPage = () => {
        if (page >= Page.Result) {
            setPage(Page.Intro);
            setVersionPick(null);
            setTypePick(null);
            setSituationPick(null);
            setClosingPick(null);
            setFastenerPick(null);
            setContactPick(null);
        } else {
            setPage(page + 1);
        }
    }

    const handlePreviousPage = () => {
        setPage(page - 1);
    }

    const phoneWidth = screenWidth < 1000;

    if (phoneWidth && !phoneMode) {
        return <PhoneStartMode enablePhoneMode={() => setPhoneMode(true)}/>
    }

    const props = {
        handleNextPage: handleNextPage,
        handlePreviousPage: handlePreviousPage,
        handlePageChange: handlePageChange,
        allValues: {VersionPick, TypePick, SituationPick, ClosingPick, FastenerPick, ContactPick}
    }

    const phoneProps = {
        ...props,
        disablePhoneMode: () => setPhoneMode(false)
    }

    let pageRender;
    switch (page) {
        case Page.Intro:
            pageRender = phoneWidth ? <PhoneIntro {...phoneProps}/> : <DesktopIntro {...props}/>;
            break;
        case Page.VersionPick:
            pageRender = phoneWidth ? <PhoneVersionPick {...phoneProps}/> : <DesktopVersionPick {...props}/>;
            break;
        case Page.TypePick:
            pageRender = phoneWidth ? <PhoneTypePick {...phoneProps}/> : <DesktopTypePick {...props}/>;
            break;
        case Page.SituationPick:
            pageRender = phoneWidth ? <PhoneSituationPick {...phoneProps}/> : <DesktopSituationPick {...props}/>;
            break;
        case Page.ClosingPick:
            pageRender = phoneWidth ? <PhoneClosingPick {...phoneProps}/> : <DesktopClosingPick {...props}/>;
            break;
        case Page.FastenerPick:
            pageRender = phoneWidth ? <PhoneFastenerPick {...phoneProps}/> : <DesktopFastenerPick {...props}/>;
            break;
        case Page.ContactPick:
            pageRender = phoneWidth ? <PhoneContactPick {...phoneProps}/> : <DesktopContactPick {...props}/>;
            break;
        case Page.Result:
            pageRender = phoneWidth ? <PhoneResult {...phoneProps}/> : <DesktopResult {...props}/>;
            break;
        default:
            console.error("Unknown page enum: " + page)
            return <p>Er is helaas iets verkeerd gegaan. Herlaad de pagina of neem contact op.</p>
    }
    return <div className={phoneMode && phoneWidth ? "phone-app" : "app"}>
        {pageRender}
    </div>
}

export default App;
